import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

const OutboundIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.94437 16.4917C9.06525 16.6011 9.22407 16.6589 9.38698 16.6528C9.54988 16.6467 9.70396 16.5773 9.81637 16.4592C9.92878 16.3412 9.99061 16.1839 9.98868 16.0208C9.98675 15.8578 9.92121 15.702 9.80604 15.5867L4.59687 10.625H16.8752C17.041 10.625 17.1999 10.5592 17.3172 10.442C17.4344 10.3247 17.5002 10.1658 17.5002 10C17.5002 9.83425 17.4344 9.67528 17.3172 9.55807C17.1999 9.44086 17.041 9.37501 16.8752 9.37501H4.59687L9.80604 4.41251C9.92121 4.29715 9.98675 4.14135 9.98868 3.97835C9.99061 3.81534 9.92878 3.65804 9.81637 3.53998C9.70396 3.42192 9.54988 3.35244 9.38698 3.34638C9.22407 3.34032 9.06525 3.39814 8.94437 3.50751L2.76104 9.39668C2.62597 9.52528 2.53794 9.69547 2.51104 9.88001C2.4967 9.95968 2.49698 10.0413 2.51187 10.1208C2.53895 10.3051 2.62697 10.475 2.76187 10.6033L8.94437 16.4917Z"
        fill="currentColor"
      />
    </svg>
  </SvgIcon>
)

export default OutboundIcon
